import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Skill: A skill that an employee possesses that can be used to inform future staffing decisions.',
    name: 'Skills',
    partialId: PartialId.Standard.create('skills'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
